// We *should* be able to just import these values from "@hookform/error-message",
// but unfortunately, the bundler isn't correctly resolving the module to use the ESM-compiled file.
// It's currently using the CJS version, which doesn't work with `useFormContext()` when running the automated tests.
// In order to make the tests pass, we have to SPECIFICALLY tell the bundler to import the ESM-compiled file.
import {
  ErrorMessage,
  type FieldValuesFromFieldErrors,
} from "@hookform/error-message/dist/index.esm.js";
import type { FieldErrors, FieldName, Message } from "react-hook-form";

import { Banner } from "mds/components/Banner";

export type ErrorMessageBannerProps<TFieldErrors extends FieldErrors> = {
  errors?: TFieldErrors;
  name: FieldName<FieldValuesFromFieldErrors<TFieldErrors>>;
  id?: string;
  className?: string;
  message?: Message;
};

export const ErrorMessageBanner = <TFieldErrors extends FieldErrors>({
  id,
  className,
  ...rest
}: ErrorMessageBannerProps<TFieldErrors>) => (
  <ErrorMessage
    render={({ message }) => (
      <Banner className={className} id={id} kind="error">
        {message}
      </Banner>
    )}
    {...rest}
  />
);
